import { yup } from '@guiker/shared-framework'

import { GuarantorStatus, Occupation, Pets, TenantApplicationProfile } from '../../../entity'

export const updatePartialTenantApplicationSchema = yup
  .object({
    userId: yup.string(),
    backgroundCheck: yup.object({
      id: yup.string(),
      legalAddress: yup.object({
        isSameAsCurrentAddress: yup.boolean(),
        address: yup.object({
          suite: yup.string(),
          streetNumber: yup.string(),
          streetName: yup.string(),
          city: yup.string(),
          state: yup.string(),
          postalCode: yup.string(),
          country: yup.string(),
        }),
      }),
      consent: yup.object({
        isConsentGiven: yup.boolean(),
      }),
    }),
    profile: yup.object({
      legalFirstName: yup.string(),
      legalLastName: yup.string(),
      emailAddress: yup.string().email(),
      phoneNumber: yup.string(),
      dateOfBirth: yup.string(),
      language: yup.mixed<TenantApplicationProfile['language']>(),
      driversLicense: yup.string(),
      estimatedCreditScore: yup.mixed<TenantApplicationProfile['estimatedCreditScore']>(),
      gender: yup.object({
        classification: yup.mixed<TenantApplicationProfile['gender']['classification']>(),
        other: yup.string(),
      }),
    }),
    currentAddress: yup.object({
      streetName: yup.string(),
      suite: yup.string(),
      streetNumber: yup.string(),
      city: yup.string(),
      state: yup.string(),
      postalCode: yup.string(),
      country: yup.string(),
      moveOutDate: yup.string(),
      yearsAtAddress: yup.number(),
      isPreviouslyLessee: yup.boolean(),
      previousLeaseInfo: yup.object({
        monthlyRent: yup.number(),
        landlord: yup.object({
          legalFirstName: yup.string(),
          legalLastName: yup.string(),
          emailAddress: yup.string().email(),
          phoneNumber: yup.string(),
        }),
      }),
    }),
    hasPets: yup.boolean(),
    pets: yup.object({
      additionalInfo: yup.string(),
      isSupportServiceAnimal: yup.boolean(),
      type: yup.mixed<Pets['type']>(),
      other: yup.string(),
    }),
    hasVehicle: yup.boolean(),
    vehicle: yup.object({
      brand: yup.string(),
      model: yup.string(),
      dateOfIssue: yup.string(),
      plateNumber: yup.string(),
    }),
    occupation: yup.object({
      type: yup.mixed<Occupation['type']>(),
      student: yup.object({
        annualSalary: yup.string(),
        studyProgram: yup.string(),
        school: yup.string(),
      }),
      professional: yup.object({
        annualSalary: yup.string(),
        linkedIn: yup.string(),
      }),
      title: yup.string(),
    }),
    hasGuarantor: yup.boolean(),
    willInviteGuarantor: yup.boolean(),
    guarantor: yup.object({
      profile: yup.object({
        userId: yup.string(),
        legalFirstName: yup.string(),
        legalLastName: yup.string(),
        emailAddress: yup.string().email(),
        dateOfBirth: yup.string(),
        occupation: yup.string(),
        relationship: yup.string(),
        annualSalary: yup.string(),
        phoneNumber: yup.string(),
        estimatedCreditScore: yup.mixed<TenantApplicationProfile['estimatedCreditScore']>(),
      }),
      address: yup.object({
        suite: yup.string(),
        streetNumber: yup.string(),
        streetName: yup.string(),
        city: yup.string(),
        state: yup.string(),
        postalCode: yup.string(),
        country: yup.string(),
      }),
      supportingDocuments: yup.array().of(
        yup.object({
          type: yup.mixed().oneOf(['governmentId', 'proofOfIncome']),
          isWaiveRequested: yup.boolean(),
          assets: yup.array().of(
            yup.object({
              id: yup.string(),
            }),
          ),
          reasonForWaive: yup.string(),
        }),
      ),
      backgroundCheck: yup.object({
        consent: yup.object({
          isConsentGiven: yup.boolean(),
          ipAddress: yup.string(),
          updatedAt: yup.string(),
        }),
        result: yup.mixed(),
        status: yup.string(),
        ssn: yup.string(),
        creditStatus: yup.string(),
        creditScore: yup.number(),
        certnScore: yup.number(),
        certnScoreLabel: yup.string(),
        updatedAt: yup.string(),
      }),
      status: yup.mixed<GuarantorStatus>(),
    }),
    // supportingDocuments: yup.array().of(
    //   yup.object({
    //     type: yup.mixed().oneOf(['governmentId', 'proofOfIncome']),
    //     isWaiveRequested: yup.boolean(),
    //     assets: yup.array().of(
    //       yup.object({
    //         id: yup.string(),
    //       })
    //     ),
    //     reasonForWaive: yup.string(),
    //   })
    // ),
  })
  .notRequired()
  .default(undefined)
